import { InputGroup } from "@blueprintjs/core";
import { ContextMenu2 } from "@blueprintjs/popover2";
import React, { MouseEventHandler, useState } from "react";

import DeleteTeamModal from "../../../../components/DeleteTeamModal/delete-team-modal";
import { PlayPropertyContextMenu } from "../../../../components/play-property-context-menu/play-property-context-menu";
import { basketball } from "../../../../images";
import { Team, useDeleteTeamMutation, useEditTeamMutation } from "../../../../redux/slices";
import teamStyles from ".././teams.tab.module.scss";

interface CustomTeamItemProps {
  handleTeamClick: MouseEventHandler<HTMLDivElement>;
  playCount: number;
  team: Team;
}

export const CustomTeamItem = ({ handleTeamClick, playCount, team }: CustomTeamItemProps) => {
  const [editingText, setEditingText] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [newName, setNewName] = useState("");

  const [deleteTeam] = useDeleteTeamMutation();
  const [editTeam] = useEditTeamMutation();

  const reset = () => {
    setEditingText(false);
    setNewName("");
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleEditClick = () => {
    setEditingText(!editingText);
  };

  const handleDeleteTeam = (e: any) => {
    e.stopPropagation();
    deleteTeam({ id: team.team_id });
    setShowDeleteModal(false);
  };

  const handleSubmitNewName = () => {
    if (!team.id || newName === team.name || !newName) {
      reset();
      return;
    }

    editTeam({ id: team.id, team_id: team.team_id, name: newName });
    reset();
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      handleSubmitNewName();
    }
  };

  return (
    <ContextMenu2
      key={team.id}
      content={<PlayPropertyContextMenu playProperty="Team" onDelete={handleDeleteClick} onEdit={handleEditClick} />}
    >
      <div className={teamStyles.teamItem} onClick={handleTeamClick}>
        <div className={teamStyles.teamIconNameContainer}>
          <div className={teamStyles.teamImageContainer}>
            <img className={teamStyles.teamImage} src={basketball} />
          </div>
          <div className={teamStyles.teamName}>
            {editingText ? (
              <InputGroup
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder={team.name}
                leftIcon="edit"
                onClick={(e) => e.stopPropagation()}
                onBlur={handleSubmitNewName}
                onKeyDown={handleKeyDown}
                autoFocus
              />
            ) : (
              team.name
            )}
          </div>
        </div>
        <div className={teamStyles.teamInfoEditContainer}>
          <div className={teamStyles.teamPlayCount}>{playCount}</div>
        </div>
      </div>
      <DeleteTeamModal
        show={showDeleteModal}
        handleClose={(e: any) => {
          e.stopPropagation();
          setShowDeleteModal(false);
        }}
        teamName={team.name}
        handleDeleteTeam={handleDeleteTeam}
      />
    </ContextMenu2>
  );
};
